import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { SiteDetailsPage } from '@/components/SiteDetailsPage'

export const Route = createFileRoute('/_protected/_site/site-details')({
  component: RouteComponent,
})

function RouteComponent() {
  const routeApi = getRouteApi("/_protected/_site")
  const data = routeApi.useLoaderData()

  return <SiteDetailsPage site={data} />
}
